exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.function-review .v-item-group > .v-btn--active {\r\n  background-color: rgb(25, 118, 210);\r\n  color: white;\n}\n.function-review table.v-table thead th.newValueHeader {\r\n  width: 170px;\n}\n.function-review .sb-table-top-actions .v-btn.table_columns_shown {\r\n  border-radius: 50%;\n}\r\n", ""]);

// exports
